var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.PrivacypolicyCn)?_c('PrivacypolicyCn'):_vm._e(),_vm._v(" "),(_vm.PrivacypolicyTw)?_c('PrivacypolicyTw'):_vm._e(),_vm._v(" "),(_vm.PrivacypolicyUs)?_c('PrivacypolicyUs'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ff3e9cf","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Privacypolicy.vue
// module id = null
// module chunks = 